import moment from 'moment'

export default {
  methods: {
    calculateAvailablePresetDiscount (item, user, quantity) {
      console.log(item, user, quantity)
      if (!item.hasOwnProperty('preset_discounts') || !Array.isArray(item.preset_discounts) || item.preset_discounts.length === 0) {
        return
      }

      let presetDiscounts = item.preset_discounts
      for (let i = 0; i < presetDiscounts.length; i++) {
        let presetDiscount = presetDiscounts[i]

        console.log('Preset Discount auto check: ', presetDiscount.Auto)
        if (presetDiscount.Auto !== 1) {
          console.log(1)
          continue
        }

        console.log('Preset Discount min order check: ', presetDiscount.MinOrder, quantity)
        if (quantity < presetDiscount.MinOrder) {
          console.log(2)
          continue
        }

        const now = moment()

        console.log('Preset Discount dates check: ', presetDiscount.DiscountStartDate, presetDiscount.DiscountEndDate)
        if (
          presetDiscount.DiscountStartDate &&
          presetDiscount.DiscountEndDate &&
          !now.isBetween(presetDiscount.DiscountStartDate, presetDiscount.DiscountEndDate)
        ) {
          console.log(3)
          continue
        }

        console.log('Preset Discount Days of week check: ', presetDiscount.DiscountDaysOfWeek)
        if (
          presetDiscount.DiscountDaysOfWeek !== 0 &&
          presetDiscount.DiscountDaysOfWeek !== '0' &&
          presetDiscount.DiscountDaysOfWeek !== null
        ) {
          let daysOfWeek = presetDiscount.DiscountDaysOfWeek.split(',').map(value => parseInt(value))

          console.log('Preset Discount Days of week check: ', daysOfWeek, now.isoWeekday())

          if (!daysOfWeek.includes(now.isoWeekday())) {
            console.log(4)
            continue
          }
        }

        // Wait check Holidays
        // The presetDiscount.AvailableDays value is "-H" when Excluding Holidays
        // The presetDiscount.AvailableDays value is null when Including Holidays
        // if (false) {
        //   console.log(5)
        //   continue
        // }

        console.log('Preset Discount time range check: ', presetDiscount.DiscountTimeRange)
        if (presetDiscount.DiscountTimeRange) {
          let times = presetDiscount.DiscountTimeRange.split('-')
          console.log('Preset Discount time range check: ', times)
          if (times.length === 2 && !now.isBetween(moment(times[0], 'kk:mm'), moment(times[1], 'kk:mm'))) {
            console.log(6)
            continue
          }
        }

        console.log('Preset Discount only member check: ', presetDiscount.OnlyMember, user)
        if (presetDiscount.OnlyMember === 1 && !user) {
          console.log(7)
          continue
        }

        return presetDiscount
      }

      return null
    },
    calculateAfterPresetDiscountPriceByItem (presetDiscount, item, quantity) {
      return this.calculateAfterPresetDiscountPriceByPrice(presetDiscount, item.price, quantity)
    },
    calculateAfterPresetDiscountPriceByPrice (presetDiscount, price, quantity) {
      let itemPrice = null
      if ((presetDiscount.Type === 1 || presetDiscount.Type === '1') && presetDiscount.Amount > 0) {
        itemPrice = price - presetDiscount.Amount
      } else if ((presetDiscount.Type === 2 || presetDiscount.Type === '2') && presetDiscount.Amount > 0) {
        itemPrice = price - (price * presetDiscount.Amount / 100)
      }
      return itemPrice === null
        ? price * quantity
        : itemPrice * quantity
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/preset_discount.js